import type { ReactNode } from 'react';

/**
 * One page block: a section title, optional supporting copy, optional trailing
 * chrome, then the body. Operational pages share this so hierarchy does not
 * drift from screen to screen.
 */
export function PageSection({
  headingId,
  title,
  description,
  aside,
  children,
}: {
  headingId: string;
  title: string;
  description?: ReactNode;
  aside?: ReactNode;
  children: ReactNode;
}): ReactNode {
  return (
    <section aria-labelledby={headingId} className="grid gap-5">
      <header className="flex flex-wrap items-start justify-between gap-3">
        <div className="min-w-0">
          <h2 id={headingId} className="text-base font-medium">
            {title}
          </h2>
          {description === undefined ? null : (
            <div className="mt-1 text-sm text-muted-foreground">{description}</div>
          )}
        </div>
        {aside === undefined ? null : (
          <div className="flex shrink-0 flex-wrap items-center gap-2">{aside}</div>
        )}
      </header>
      {children}
    </section>
  );
}
